import React, { FC, useEffect } from "react";

import { KpkApiPublicShareExportDefinition } from "@keepeek/api-client";
import { useBasketShare } from "@keepeek/commons";
import { KModalContentSection, withSuspense } from "@keepeek/refront-components";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";

import { CommonBasketShareProps } from "./index";

const PublicShareAttachmentsVisible: FC<CommonBasketShareProps> = function ({
  basketId,
  sentryCallback,
  snackbarCallback,
}) {
  const { t } = useTranslation();
  const { displayBackofficeSharedBasket } = useRecoilValue(
    configSectionComponentBasketSelector,
  ) ?? {
    displayBackofficeSharedBasket: undefined,
  };
  const { selectedAttachmentsVisible, selectedExportDefinition, setSelectedAttachmentsVisible } =
    useBasketShare(
      displayBackofficeSharedBasket ?? false,
      basketId,
      sentryCallback,
      snackbarCallback,
    );

  useEffect(() => {
    // Uncheck attachments visible while moving from HD definition
    if (
      selectedAttachmentsVisible.attachmentsVisible &&
      selectedExportDefinition !== KpkApiPublicShareExportDefinition.HD
    ) {
      setSelectedAttachmentsVisible((currVal) => ({
        ...currVal,
        attachmentsVisible: false,
      }));
    }
  }, [selectedAttachmentsVisible, selectedExportDefinition, setSelectedAttachmentsVisible]);

  return (
    <KModalContentSection
      title={t("basket.share.content.attachments-visible.title") as string}
      description={t("basket.share.content.attachments-visible.description") as string}
    >
      <FormControlLabel
        disabled={selectedExportDefinition !== KpkApiPublicShareExportDefinition.HD}
        control={
          <Checkbox
            id="PublicShareAttachmentsVisibleInput"
            aria-label={t("basket.share.content.attachments-visible.input.label") as string}
            checked={selectedAttachmentsVisible.attachmentsVisible}
            onChange={(e) => {
              setSelectedAttachmentsVisible((currVal) => ({
                ...currVal,
                attachmentsVisible: e.target.checked,
              }));
            }}
          />
        }
        label={t("basket.share.content.attachments-visible.checkbox.label") as string}
      />
    </KModalContentSection>
  );
};

export default withSuspense(PublicShareAttachmentsVisible);
